// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e44aa9b5","488":"e86e8dde"}[chunkId] + ".chunk.js";
};